import { getAccessToken } from '../shared/tokenUtils';
import store from "../store";
import { signOut } from "../actions/auth/creators/SignOut";
import { push } from "react-router-redux";
require('isomorphic-fetch');
export var CALL_API = Symbol('Call API');
export function callApi(endpoint, method, data, passCredentials) {
    var date = new Date();
    var antiCacheEndpoint = endpoint.split('?').length > 1 ?
        "".concat(endpoint, "&t=").concat(date.getTime()) :
        "".concat(endpoint, "?t=").concat(date.getTime());
    var token = getAccessToken();
    function checkStatus(response) {
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        else if (response.status === 401 && token) {
            store.dispatch(signOut());
            return store.dispatch(push('/'));
        }
        else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    }
    var headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
    if (token) {
        headers.authorization = "Bearer ".concat(token);
    }
    return fetch(antiCacheEndpoint, {
        method: method,
        headers: headers,
        credentials: passCredentials ? 'same-origin' : undefined,
        body: method === 'get' ? undefined : JSON.stringify(data)
    }).then(checkStatus).then(function (response) {
        if (!response.ok) {
            return Promise.reject(response);
        }
        return response.json().then(function (json) { return ({ json: json, response: response }); });
    }).then(function (_a) {
        var json = _a.json, response = _a.response;
        if (!response.ok) {
            return Promise.reject(json);
        }
        return json;
    }).catch(function (err) {
        return err;
    });
}
export default (function (store) { return function (next) { return function (action) {
    var callAPI = action[CALL_API];
    if (typeof callAPI === 'undefined') {
        return next(action);
    }
    var type = action.type;
    var endpoint = callAPI.endpoint;
    var method = callAPI.method, _a = callAPI.types, successType = _a[0], failureType = _a[1], credentials = callAPI.credentials, data = callAPI.data;
    function actionWith(data) {
        var finalAction = Object.assign({}, action, data);
        delete finalAction[CALL_API];
        return finalAction;
    }
    next(actionWith({ type: type, data: data }));
    return callApi(endpoint, method, data, credentials).then(function (res) {
        var actionsChain = Array.isArray(successType) ? successType : [successType];
        if (res !== null && res.response && !res.response.ok) {
            next(actionWith({
                type: failureType,
                data: Object.assign({}, data, {
                    error: res.message
                })
            }));
        }
        else {
            for (var i = 0; i < actionsChain.length; i++) {
                var actionType = actionsChain[i];
                if (typeof (actionType) === 'function') {
                    res = actionType(res);
                }
                else {
                    next(actionWith({
                        data: res,
                        type: actionType
                    }));
                }
            }
        }
    }, function (error) { return next(actionWith({
        type: failureType,
        data: Object.assign({}, data, {
            error: error.message
        })
    })); });
}; }; });



// WEBPACK FOOTER //
// ./src/middleware/api.js